var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "pop-dialog pop-set-remark",
      attrs: {
        title: _vm.popTitle,
        visible: _vm.visibleDialog,
        width: "424px",
        top: _vm.popTop,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleDialog = $event
        },
      },
    },
    [
      _vm.type === "remark"
        ? _c(
            "div",
            { staticClass: "remak-con" },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 3,
                  maxlength: "64",
                  placeholder: "请输入备注信息…",
                },
                model: {
                  value: _vm.textarea,
                  callback: function ($$v) {
                    _vm.textarea = $$v
                  },
                  expression: "textarea",
                },
              }),
            ],
            1
          )
        : _vm.type === "afterSale"
        ? _c(
            "div",
            { staticClass: "remak-con" },
            _vm._l(_vm.saleList, function (item, index) {
              return _c("div", { key: index, staticClass: "item-remark" }, [
                _c("div", { staticClass: "item-title" }, [
                  _vm._v("售后单" + _vm._s(item.afterSalesNo)),
                ]),
                _c(
                  "div",
                  { staticClass: "item-con" },
                  [
                    _c("div", { staticClass: "item-label" }, [_vm._v("备注")]),
                    _c("el-input", {
                      staticClass: "item-input",
                      attrs: {
                        type: "textarea",
                        rows: 3,
                        maxlength: "64",
                        placeholder: "请输入备注信息…",
                      },
                      model: {
                        value: item.remark,
                        callback: function ($$v) {
                          _vm.$set(item, "remark", $$v)
                        },
                        expression: "item.remark",
                      },
                    }),
                  ],
                  1
                ),
              ])
            }),
            0
          )
        : _vm._e(),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini" },
              on: {
                click: function ($event) {
                  _vm.visibleDialog = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini", loading: _vm.loading },
              on: { click: _vm.onConfirm },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }